module.exports = __webpack_public_path__ + "assets/star-active.0e85bb9c.svg";